import './copyableText.scss'
import CopyIcon from '../../assets/icons/copy.svg'
import { useState } from 'react'

interface CopyableTextProps {
    text: string
}

export const CopyableText = ({ text }: CopyableTextProps) => {
    const [isCopied, setIsCopied] = useState(false)

    const copyText = () => {
        navigator.clipboard.writeText(text).then(() => {
            setIsCopied(true)
            setTimeout(() => {
                setIsCopied(false)
            }, 2000)
        })
    }

    return (
        <span className="copyable-text" onClick={copyText}>
            <span className="copyable-text__text">{text}</span>
            <img
                src={CopyIcon}
                alt="Icon description"
                className="copyable-text__icon"
            />
            {isCopied && (
                <span className="copyable-text__tooltip">Copied!</span>
            )}
        </span>
    )
}
